import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./AgritourismL2.module.css";

function AgritourismL2({ distrito }) {
  const [agroturismo, setAgroturismo] = useState(null);
  const [dificuldadeAgroturismo, setDificuldadeAgroturismo] = useState(null);
  const [formaDeRenda, setFormaDeRenda] = useState(null);
  const [interesseAgroturismo, setInteresseAgroturismo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          agroturismo,
          dificuldadeAgroturismo,
          formaDeRenda,
          interesseAgroturismo,
        ] = await Promise.all([
          Api.getAgroturismo(distrito),
          Api.getDificuldadeAgroturismo(distrito),
          Api.getFormaDeRenda(distrito),
          Api.getInteresseAgroturismo(distrito),
        ]);
        setAgroturismo(Functions.buildSmallPieGraphParams(agroturismo));
        setDificuldadeAgroturismo(
          Functions.buildPieGraphParams2(dificuldadeAgroturismo)
        );
        setFormaDeRenda(Functions.buildPieGraphParams2(formaDeRenda));
        setInteresseAgroturismo(
          Functions.buildPieGraphParams2(interesseAgroturismo)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.agritourismL2}>
      <div className={styles.grade}>
        <div className={styles.smallPiegraph}>
          {agroturismo && (
            <SmallPieGraph
              data={agroturismo}
              text="AGROTURISMO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {formaDeRenda && (
            <PieGraph
              data={formaDeRenda}
              text="FORMAS DE RENDA"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {interesseAgroturismo && (
            <PieGraph
              data={interesseAgroturismo}
              text="TÊM INTERESSE EM AGROTURISMO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
        <div className={styles.smallPiegraph}>
          {dificuldadeAgroturismo && (
            <PieGraph
              data={dificuldadeAgroturismo}
              text="DIFICULDADE EM AGROTURISMO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AgritourismL2;
